import React from 'react'
import { useState, useEffect, useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { drawGraphToCanvas, nodeInCoord, arcInCoord, NODE_SIZE } from './AvpGrafoCanvasUtil';
import { useEffectOnce } from '../shared/manager/use_effect_once';

export default function AvpGrafo({ data, pNode, addCallback, duplicateCallback, deleteCallback, selectedCallback, arcCallback }) {

  const canvasContRef = useRef(null)
  const canvasRef = useRef(null)
  const [canvasCursor, setCanvasCursor] = useState("pointer");
  const [canvasScale, setCanvasScale] = useState(1);
  const [selectedNode, setSelectedNode] = useState(null);
  const [nodeToolbarStatus, setNodeToolbarStatus] = useState(null);
  const [canvasTransform, setCanvasTransform] = useState(
    {
      x: 0,
      y: 0,

    }
  );
  const [trackMouseMove, setTrackMouseMove] = useState(false);
  const [previousX, setPreviousX] = useState(0);
  const [previousY, setPreviousY] = useState(0);

  const [tooltipStatus, setTooltipStatus] = useState(null);

  const [arcTextPositions, setArcTextPositions] = useState([]);

  useEffectOnce(() => {
    initComp();

    return;
  });

  function initComp() {
    console.log("initComp");


  }

  useEffect(() => {

    if (pNode != null) {
      setSelectedNode(pNode);
    }
    else {
      setNodeToolbarStatus(false);
    }


    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    // Controlla se `data` e `data.nodi` sono definiti prima di procedere
    if (data && Array.isArray(data.nodi)) {
      drawGraphWithTextTracking(context, canvasContRef.current, data, selectedNode, canvasScale, canvasTransform);
    } else {
      console.warn("Il grafo non è definito correttamente: `data` o `data.nodi` è null");
    }


  }, [data, selectedNode, canvasScale, canvasTransform])


  // Funzione per disegnare il grafo e tracciare le posizioni del testo degli archi
  function drawGraphWithTextTracking(context, container, graphData, graphSelectedNode, scale, transform) {
    // Disegna il grafo
    drawGraphToCanvas(context, container, graphData, graphSelectedNode, scale, transform);

    // Reset delle posizioni del testo
    const newArcTextPositions = [];

    // Traccia le posizioni del testo per ogni arco
    graphData.nodi.forEach((nodo) => {
      nodo.archi.forEach((arc) => {
        const { posX, posY } = calculateTextPosition(nodo, arc, scale, transform);
        const text = arc.testo;

        // Determina un’area attorno al testo (10px di altezza e una larghezza proporzionale alla lunghezza del testo)
        newArcTextPositions.push({
          x: posX,
          y: posY,
          width: context.measureText(text).width,
          height: 10,
          text: text
        });
      });
    });

    setArcTextPositions(newArcTextPositions);
  }

  // Calcola la posizione del testo per un arco
  function calculateTextPosition(startNode, arc, scale, transform) {
    const endNode = data.nodi.find((n) => n.idNodo === arc.idNodoEnd);

    if (endNode) {

      let sX = startNode.posX + NODE_SIZE / 2;
      let sY = startNode.posY + NODE_SIZE / 2;
      let eX = endNode.posX + NODE_SIZE / 2;
      let eY = endNode.posY + NODE_SIZE / 2;

      let padd = 5;
      sX = sX + padd;
      sY = sY - padd;
      eX = eX + padd;
      eY = eY - padd;
      let angle = angleBetweenPoints(sX, sY, eX, eY);
      if (endNode.posX < startNode.posX) {
        sX = sX - padd;
        sY = sY - padd;
        eX = eX - padd;
        eY = eY - padd;
        angle = angleBetweenPoints(sX, sY, eX, eY) + Math.PI;//  -angleBetweenPoints(sX, sY, eX, eY);
      }

      let posX = sX + (eX - sX) / 2;
      let posY = sY + (eY - sY) / 2;


      return {
        posX: posX,
        posY: posY
      };
    }
    return { posX: 0, posY: 0 };
  }

  function onCanvasMouseDown(e) {
    console.log("onCanvasMouseDown");
    //e.preventDefault();

    setPreviousX(e.clientX);
    setPreviousY(e.clientY);
    setTrackMouseMove(true);

    if (selectedNode != null) {
      setSelectedNode(null);
      if (selectedCallback != null)
        selectedCallback(null);

      setNodeToolbarStatus(null);
      setTooltipStatus(null);
    }

  }

  function onCanvasMouseUp(e) {
    console.log("onCanvasMouseUp");
    //e.preventDefault();

    setPreviousX(e.clientX);
    setPreviousY(e.clientY);
    setTrackMouseMove(false);
  }

  function onCanvasMouseLeave(e) {
    console.log("onCanvasMouseLeave");
    //e.preventDefault();

    setPreviousX(e.clientX);
    setPreviousY(e.clientY);
    setTrackMouseMove(false);
  }

  function onCanvasMouseMove(e) {
    if (trackMouseMove) {
      updatePanning(e);
    } else {
      const localX = e.nativeEvent.offsetX;
      const localY = e.nativeEvent.offsetY;

      // Verifica se il mouse è sopra un testo di un arco
      let contentText = "";
      const arcText = arcTextPositions.find((pos) =>
        localX >= pos.x &&
        localX <= pos.x + pos.width &&
        localY >= pos.y &&
        localY <= pos.y + pos.height
      );

      //verifica se sono su una linea di un arco
      var line = arcInCoord(localX, localY, canvasScale, canvasTransform);
      var node = nodeInCoord(localX, localY, canvasScale, canvasTransform);

      if ((line && !node) || arcText) {
        contentText = (arcText) ? arcText.text : line.label;
        setTooltipStatus({
          posX: localX + 10, // Offset per una migliore visibilità
          posY: localY + 10,
          content: contentText
        });
      } else {
        setTooltipStatus(null);
      }
    }
  }

  function angleBetweenPoints(cx, cy, ex, ey) {
    var dy = ey - cy;
    var dx = ex - cx;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    //theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    //if (theta < 0) theta = 360 + theta; // range [0, 360)
    return theta;
  }

  function onCanvasClick(e) {
    console.log("click at X=" + e.nativeEvent.offsetX + "  y=" + e.nativeEvent.offsetY);
    console.log("canvasScale", canvasScale);
    let clickX = e.nativeEvent.offsetX;
    let clickY = e.nativeEvent.offsetY;
    var node = nodeInCoord(clickX, clickY, canvasScale, canvasTransform);
    if (node != null) {
      //console.log(node);

      setSelectedNode(node);
      if (selectedCallback != null)
        selectedCallback(node);

      if (node.nodoStart == false) {
        //SHOW TOOLBAR
        let tX = canvasTransform != null && canvasTransform !== "undefined" ? canvasTransform.x : 0;
        let tY = canvasTransform != null && canvasTransform !== "undefined" ? canvasTransform.y : 0;
        let nodeSize = NODE_SIZE * canvasScale;
        let nodeX = (node.posX * canvasScale) + tX;
        let nodeY = (node.posY * canvasScale) + tY;
        setNodeToolbarStatus(
          {
            posX: (nodeX + (nodeSize / 2) - 73),
            posY: (nodeY - 50)
          }
        );
      }
      else {
        setNodeToolbarStatus(null);
      }

    }
    else {
      var arc = arcInCoord(clickX, clickY, canvasScale, canvasTransform);
      if (arc != null) {
        if (arcCallback != null) {
          arcCallback(arc);
        }
      }
      else {
        setSelectedNode(null);
        if (selectedCallback != null)
          selectedCallback(null);
        setNodeToolbarStatus(null);
      }

    }
  }

  function updatePanning(e) {
    const localX = e.clientX;
    const localY = e.clientY;

    canvasTransform.x += (localX - previousX) / 2;
    canvasTransform.y += (localY - previousY) / 2;

    setPreviousX(localX);
    setPreviousY(localY);

    let newObj = Object.assign({}, canvasTransform);
    setCanvasTransform(newObj);
    console.log("updatePanning at X=" + canvasTransform.x + "  y=" + canvasTransform.y);
  }

  /*
  
    function assignEventListener(canvas) {
  
  
      console.log("assignnnnn");
      
      canvas.removeEventListener("click", clickListener);
      canvas.addEventListener("click", clickListener); 	
    
      canvas.removeEventListener("mousedown", mouseDownListener);
      canvas.addEventListener("mousedown", mouseDownListener);
  
      canvas.removeEventListener("mouseup", mouseUpListener);
      canvas.addEventListener("mouseup", mouseUpListener);
  
      canvas.removeEventListener("mousemove", mouseMoveListener);
      canvas.addEventListener("mousemove", mouseMoveListener);
  
    
  
    }
  */

  function zoomin() {
    let scale = canvasScale + 0.1;
    console.log("zoomin " + scale);
    setCanvasScale(scale);
    setNodeToolbarStatus(null);
  }

  function zoomout() {
    let scale = canvasScale - 0.1;
    console.log("zoomout " + scale);
    setCanvasScale(scale);
    setNodeToolbarStatus(null);
  }


  function handleAdd() {
    if (addCallback != null) {
      addCallback(selectedNode);
    }
  }
  function handleDuplicate() {
    if (duplicateCallback != null) {
      duplicateCallback(selectedNode);
    }
  }
  function handleDelete() {
    if (deleteCallback != null) {
      deleteCallback(selectedNode);
    }
  }

  return (
    <div id="avp-grafo-canvas-container" ref={canvasContRef} >
      <canvas id="avp-grafo-canvas" ref={canvasRef} style={{ cursor: canvasCursor }} onClick={onCanvasClick} onMouseDown={onCanvasMouseDown} onMouseUp={onCanvasMouseUp} onMouseMove={onCanvasMouseMove} onMouseLeave={onCanvasMouseLeave} ></canvas>
      <IconButton color="#ffffff" aria-label="zoom in" id="avp-grafo-zoomin-button" onClick={() => zoomin()}>
        <ZoomIn />
      </IconButton>
      <IconButton color="#ffffff" aria-label="zoom out" id="avp-grafo-zoomout-button" onClick={() => zoomout()} >
        <ZoomOut />
      </IconButton>
      <div id="avp-grafo-nodetoolbar" style={{ "display": (nodeToolbarStatus != null && nodeToolbarStatus.posX != null ? "block" : "none"), "top": (nodeToolbarStatus != null ? nodeToolbarStatus.posY : 0), "left": (nodeToolbarStatus != null ? nodeToolbarStatus.posX : 0) }}  >
        <img src="/images/add_node_btn.svg" onClick={handleAdd} />
        <img src="/images/duplicate_node_btn.svg" onClick={handleDuplicate} />
        <img src="/images/delete_btn.svg" onClick={handleDelete} />
      </div>
      <div
        id="avp-grafo-tooltip"
        style={{
          display: tooltipStatus ? "block" : "none",
          top: tooltipStatus?.posY || 0,
          left: tooltipStatus?.posX || 0,
          padding: "5px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          color: "#ffffff",
          borderRadius: "4px",
          position: "absolute",
          pointerEvents: "none",
          transform: "translate(10px, 10px)"
        }}
      >
        {tooltipStatus?.content || ""}
      </div>
    </div>


  );

} 